<!--
 * @Description : 获取图片验证码
 * @Author      : pishengjun
 * @Date        : 2025-03-05 17:12:01
-->
<template>
  <img :src="verificationCode" class="verificationCode" title="点击刷新验证码" alt="验证码图片" @click="onVerificationCodeClick" />
</template>

<script lang="ts">
import { RandomVerificationCodeClass } from "@/http/api/FaceRecognitionService";
import { defineComponent, reactive, toRefs, onMounted } from "vue";
import { nanoid } from "nanoid";

export default defineComponent({
  name: "RandomVerificationCode",
  emits: ["onGetData"],
  setup(props, { emit, expose }) {
    onMounted(() => event.GetRandomVerificationCodeMd5());
    const state = reactive({
      verificationCode: "",
    });
    const event = {
      async GetRandomVerificationCodeMd5() {
        // 发送请求获取图片验证码
        const randomMark = nanoid();
        const result = await RandomVerificationCodeClass.GetRandomVerificationCodeMd5(randomMark);
        state.verificationCode = result.verificationCodeImageBase64;
        emit("onGetData", {
          randomMark,
          verificationCodeMd5: result.verificationCodeMd5,
          verificationCodeImageBase64: result.verificationCodeImageBase64,
        });
      },
      onVerificationCodeClick() {
        // 点击图片验证码时刷新图片验证码
        event.GetRandomVerificationCodeMd5();
      },
    };

    // 暴露方法
    expose({
      GetRandomVerificationCodeMd5: event.GetRandomVerificationCodeMd5,
    });

    return {
      ...toRefs(state),
      ...event,
    };
  },
});
</script>

<style lang="less" scoped>
.verificationCode {
  width: 120px;
  height: auto;
  cursor: pointer;
}
</style>
